export const GROUP_NAME = 'cute-icon'

export enum Colors {
  Blue = 'blue',
  Green = 'green',
  Pink = 'pink',
  Purple = 'purple',
  Yellow = 'yellow',
}

export const DEFAULT_COLOR = Colors.Pink
